<script>
import Wallet from "@/components/_Shared/Wallet.vue";

export default {
  components: {
    Wallet
  },

  data() {
    return {
      wallet: {
        icon: "menu-wallet-of-company.svg",
        value: "935,00",
        futureBalance: "400,50",
        blockedBalance: "400,50",
        button: {
          title: "sacar"
        }
      }
    };
  }
};
</script>

<template>
  <div class="box">
    <div class="title mb-40">Carteira da empresa</div>

    <div class="row justify-center">
      <Wallet :data="wallet"/>
    </div>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/WalletOfCompany/Wallet.vue